import { useState, useRef } from 'preact/hooks'

const IGNORE_PROPERTIES = [
  'timestamp',
  'byopBundles',
  'byopAddon',
  'Add Message color',
  'isCartGift',
  'Assemble',
  '_sherpaid',
  'in-store-only',
  'store-only',
  'productContain',
  'thisProductId',
  '_productType',
  '_intuitive_cid'
]
const RENAME_PROPERTIES = [
  {
    trueName: 'pickupLocationName',
    prettyName: 'Pick up location'
  },
  {
    trueName: 'pickupLocationProvinceCode',
    prettyName: 'Pick up state'
  }
]

function CartInfo({ infos, properties, isGiftCard, isHidden }) {
  const content = useRef(null)
  const [active, setActive] = useState(false)
  const [style, setStyle] = useState('height: 0')
  const [hasContent, setHasContent] = useState(false)

  const toggleActive = () => {
    if (!active) {
      setStyle(`height: ${content.current.scrollHeight}px`)
    } else {
      setStyle('height: 0')
    }
    setActive(!active)
  }

  const getPropertyType = (properties) => {
    if (properties.some((item) => item.name === 'byopBundles')) {
      return 'byopBundles'
    }
    if (properties.some((item) => item.name === 'productContain')) {
      return 'productContain'
    }
    return ''
  }

  const propertyType = getPropertyType(properties)

  const getPropertyNameRemoveSku = (property) => {
    setHasContent(true)
    if (property.key === 'true' || property.key === 'false') {
      if (property.key === 'true') {
        return renderLineProperty(`${property.name}: Yes`)
      } else {
        return renderLineProperty(`${property.name}: No`)
      }
    } else if (typeof property.key === 'string' && property.key.includes('|')) {
      const splitValue = property.key.split('|')[1]
      if (splitValue) {
        return renderLineProperty(`${splitValue} x ${property.name}`)
      } else {
        const value = property.key.split('|')[0]
        return renderLineProperty(`${value} x ${property.name}`)
      }
    } else {
      return renderLineProperty(`${property.key} x ${property.name}`)
    }
  }

  /**
   *
   * @param {
   *  {
   *    name: string
   *    key: string
   *  }
   * } property the key here is actually the value
   * @returns
   */
  const getLineProperty = (property) => {
    if (IGNORE_PROPERTIES.some((item) => property.name.includes(item))) {
      return ''
    }
    const renameProperty = RENAME_PROPERTIES.find(x => x.trueName === property.name)
    if (
      isGiftCard ||
      property.name.includes('Add Message') ||
      property.name.includes('spiffTransactionId') ||
      renameProperty
    ) {
      const propertyName = renameProperty?.prettyName || property.name
      return renderLineProperty(`${propertyName}: ${property.key}`)
    } else {
      switch (propertyType) {
        case 'byopBundles':
          return getPropertyNameRemoveSku(property)
        case 'productContain':
          return getPropertyNameRemoveSku(property)
        default:
          return renderLineProperty(`${property.key} x ${property.name}`)
      }
    }
  }

  const renderLineProperty = (text) => {
    setHasContent(true)
    return <span className="block mb-2 text-xs tracking-normal text-grey-700">{text}</span>
  }

  return (
    !isHidden &&
    <div>
      {infos.map((info) => (
        <span className="text-label tracking-normal text-grey-500 mt-0.5">{info.name}</span>
      ))}
      {properties.length > 0 && (
        <div className={`flex flex-col mt-0.5 ${hasContent ? 'block' : 'hidden'}`}>
          <div ref={content} className="overflow-hidden transition-[height]" style={style}>
            {properties.map((property) => getLineProperty(property))}
          </div>
          <button type="button" className="flex items-center text-sm text-grey-500" onClick={toggleActive}>
            <svg className="w-4 h-4 mr-0.5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              {active ? (
                <path id="icon-minus" d="M15.625 10H4.375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
              ) : (
                <path id="icon-plus" d="M10 4.375v11.25M15.625 10H4.375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
              )}
            </svg>
            {active ? 'Hide selections' : 'View selections'}
          </button>
        </div>
      )}
    </div>
  )
}

export default CartInfo
